<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">发放明细</span>
        <el-button type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <STable
        v-if="this.dataId"
        ref="tableref"
        :url="url"
        :content-type="contentType"
        :columns="columns"
        :handles="handles"
        :query="query"
        :toolbar="toolbar"
        label-width="100px"
      />
      <el-dialog
        v-if="toVoidDialog"
        v-dialogDrag
        title="作废"
        :visible.sync="toVoidDialog"
        :close-on-click-modal="false"
        width="50%"
        center
      >
        <div style="width: 90%;margin:0 auto">
          <el-form ref="toVoidFormRef" :model="toVoidForm" :rules="toVoidRules" label-width="80px">
            <el-form-item label="备注" prop="remark">
              <el-input v-model="toVoidForm.remark" type="textarea" :rows="4" placeholder="请输入作废原因" />
            </el-form-item>
          </el-form>
        </div>
        <div class="flexJCenter mt-25">
          <el-button @click="closeDialogx">取消</el-button>
          <el-button type="primary" @click="onSubmitx()">保存</el-button>
        </div>
      </el-dialog>
      <el-dialog
        v-if="writeOffDialog"
        v-dialogDrag
        title="手动核销"
        :visible.sync="writeOffDialog"
        :close-on-click-modal="false"
        width="50%"
        center
      >
        <div style="width: 90%;margin:0 auto">
          <el-form ref="writeOffFormRef" :model="writeOffForm" :rules="writeOffRules" label-width="80px">
            <el-form-item label="关联订单" prop="orderNo">
              <el-input v-model="writeOffForm.orderNo" placeholder="请输入消费券的关联订单" />
            </el-form-item>
            <el-form-item label="备注" prop="remark">
              <el-input v-model="writeOffForm.remark" type="textarea" :rows="4" placeholder="请输入备注信息，例如：用户优惠金额已线下补偿" />
            </el-form-item>
          </el-form>
        </div>
        <div class="flexJCenter mt-25">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="onSubmit()">保存</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
export default {
  data() {
    return {
      dataId: '',
      writeOffDialog: false,
      toVoidDialog: false,
      writeOffForm: {
        userCouponId: [],
        orderNo: '',
        remark: ''
      },
      toVoidForm: {
        userCouponId: [],
        remark: ''
      },
      toVoidRules: {
        remark: [
          { required: true, message: '请输入作废原因', trigger: 'blur' }
        ]
      },
      writeOffRules: {
        orderNo: [],
        remark: []
      },
      url: '',
      columns: [
        {
          label: '优惠券编号',
          prop: 'couponCode'
        }, {
          label: '使用状态',
          prop: 'status',
          template: function(index, record) {
            const status = record.status
            if (status === 1) {
              return '未使用'
            } else if (status === 2) {
              return '自动核销'
            } else if (status === 3) {
              return '手动核销'
            } else if (status === 4) {
              return '作废'
            }
            return record.status
          }
        }, {
          label: '是否过期',
          prop: 'useable',
          template: function(index, record) {
            return record.useable ? '否' : '是'
          }
        }, {
          label: '发放用户',
          prop: 'userName'
        }, {
          label: '用户归属企业',
          prop: 'orgName'
        }, {
          label: '关联活动/任务',
          prop: 'senterName'
        }, {
          label: '发放时间',
          prop: 'createTime',
          width: '150px'
        }, {
          label: '核销时间',
          prop: 'usedTime',
          width: '150px'
        }, {
          label: '关联订单',
          prop: 'orderNo'
        }, {
          label: '备注',
          prop: 'remarks'
        }
      ],
      handles: {
        width: 200,
        btns: [
          {
            label: '手动核销',
            permission: 'coupons.manage.release.details.manualWriteoff',
            getLabelDisabled: record => {
              return !(Number(record.status) === 1)
            },
            handle: (index, record) => {
              this.writeOffForm = {
                userCouponId: [],
                orderNo: '',
                remark: ''
              }
              this.writeOffDialog = true
              this.writeOffForm.userCouponId.push(index.id)
            }
          },
          {
            label: '作废',
            permission: 'coupons.manage.release.details.invalidation',
            getLabelDisabled: record => {
              return !(Number(record.status) === 1)
            },
            handle: (index, record) => {
              this.toVoidForm = {
                userCouponId: [],
                remark: ''
              }
              this.toVoidDialog = true
              this.toVoidForm.userCouponId.push(index.id)
            }
          }
        ]
      },
      query: [
        {
          label: '优惠券编号',
          prop: 'couponCode',
          placeholder: '请输入优惠券编号'
        },
        {
          label: '使用状态',
          prop: 'status',
          placeholder: '请输入使用状态',
          type: 'select',
          data: [{
            label: '未使用',
            value: 1
          }, {
            label: '自动核销',
            value: 2
          }, {
            label: '手动核销',
            value: 3
          }, {
            label: '作废',
            value: 4
          }]
        },
        {
          label: '是否过期',
          prop: 'useable',
          placeholder: '请选择是否过期',
          type: 'select',
          data: [{
            label: '否',
            value: true
          }, {
            label: '是',
            value: false
          }]
        },
        {
          label: '发放用户',
          prop: 'userName',
          placeholder: '请输入发放用户'
        },
        {
          label: '用户所属企业',
          prop: 'orgName',
          placeholder: '请输入用户所属企业'
        },
        {
          label: '关联活动',
          prop: 'senterName',
          placeholder: '请输入关联活动'
        },
        {
          label: '发放时间',
          prop: 'createTime',
          placeholder: '',
          type: 'date2'
        },
        {
          label: '核销时间',
          prop: 'usedTime',
          placeholder: '',
          type: 'date2'
        }
      ],
      toolbar: [
        {
          label: '导出',
          icon: 'el-icon-download',
          type: 'primary',
          permission: 'coupons.manage.release.details.export',
          handle: (index, record) => {
            const url = HOST + '/admin/coupon/exportUserCouponList?type=2&couponId=' + this.dataId
            const data = this.$refs.tableref.getQueryData()
            $.fileDownload(url, {
              httpMethod: 'GET',
              data: {
                token: window.localStorage.getItem('token'),
                ...data
              },
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出发放记录失败',
                  type: 'error'
                })
              }
            })
          }
        },
        {
          label: '批量作废',
          icon: ' ',
          type: 'primary',
          permission: 'coupons.manage.release.details.batchInvalidation',
          isSelectRowShow: true,
          before: records => {
            this.toVoidForm = {
              userCouponId: [],
              remark: ''
            }
            this.toVoidForm.userCouponId = records.map(item => {
              return item.id
            })
            this.toVoidDialog = true
          }
        }
      ]
    }
  },
  mounted() {
    // 接收数据后回显赋值
    this.$nextTick(() => {
      console.log('接收到的数据', this.$route.query)
      this.dataId = this.$route.query.couponId
      this.url = '/admin/coupon/getUserCouponList?couponId=' + this.dataId
    })
  },
  methods: {
    // 关闭手动核销的弹窗
    closeDialog() {
      this.writeOffDialog = false
    },
    // 关闭作废的弹窗
    closeDialogx() {
      this.toVoidDialog = false
    },
    // 手动核销提交
    onSubmit() {
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/useUserCoupon',
        method: 'post',
        data: this.writeOffForm,
        callback: resp => {
          this.writeOffDialog = false
          this.$refs.tableref.queryTable()
        }
      })
    },
    // 作废提交
    onSubmitx() {
      this.$store.dispatch('form/handle', {
        url: '/admin/coupon/cancelUserCoupon',
        method: 'post',
        data: this.toVoidForm,
        callback: resp => {
          this.toVoidDialog = false
          this.$refs.tableref.queryTable()
          this.$refs.tableref.selectClear()
        }
      })
    },
    // 返回
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
  .flexJCenter{
    display: flex;
    justify-content: center;
  }
  .mt-25{
    margin-top: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/views/discount/couponIssuanceDetails.vue